import { adjustmentSessionIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const cancelAdjustmentSession = {
  name: "cancelAdjustmentSession" as const,
  input: z.object({ sessionId: adjustmentSessionIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
